const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const BASE = `${API_URL}/api/v1/admin/call-masking`;

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

// ── Numbers ─────────────────────────────────────────────

const addNumber = async (body) => {
  const res = await fetch(`${BASE}/numbers`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
  return res.json();
};

const listNumbers = async (params = {}) => {
  const qs = new URLSearchParams();
  if (params.status) qs.append('status', params.status);
  if (params.provider) qs.append('provider', params.provider);
  if (params.numberType) qs.append('numberType', params.numberType);
  if (params.search) qs.append('search', params.search);
  if (params.page != null) qs.append('page', params.page);
  if (params.limit != null) qs.append('limit', params.limit);
  const url = `${BASE}/numbers${qs.toString() ? `?${qs}` : ''}`;
  const res = await fetch(url, { headers: getAuthHeaders() });
  return res.json();
};

const updateNumber = async (phoneNumber, body) => {
  const encoded = encodeURIComponent(phoneNumber);
  const res = await fetch(`${BASE}/numbers/${encoded}/status`, {
    method: 'PATCH',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
  return res.json();
};

// ── Pool Stats ──────────────────────────────────────────

const getPoolStats = async () => {
  const res = await fetch(`${BASE}/pool-stats`, {
    headers: getAuthHeaders(),
  });
  return res.json();
};

// ── Sessions ────────────────────────────────────────────

const listActiveSessions = async (params = {}) => {
  const qs = new URLSearchParams();
  if (params.orderId) qs.append('orderId', params.orderId);
  if (params.maskedNumber) qs.append('maskedNumber', params.maskedNumber);
  if (params.type) qs.append('type', params.type);
  if (params.page != null) qs.append('page', params.page);
  if (params.limit != null) qs.append('limit', params.limit);
  const url = `${BASE}/sessions/active${qs.toString() ? `?${qs}` : ''}`;
  const res = await fetch(url, { headers: getAuthHeaders() });
  return res.json();
};

const getSession = async (sessionId) => {
  const res = await fetch(`${BASE}/sessions/${sessionId}`, {
    headers: getAuthHeaders(),
  });
  return res.json();
};

const forceExpireSession = async (sessionId) => {
  const res = await fetch(`${BASE}/sessions/${sessionId}/expire`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  return res.json();
};

// ── Calls (Twilio only) ─────────────────────────────────

const getCallHistory = async (params = {}) => {
  const qs = new URLSearchParams();
  if (params.phoneNumber) qs.append('phoneNumber', params.phoneNumber);
  if (params.from) qs.append('from', params.from);
  if (params.to) qs.append('to', params.to);
  if (params.status) qs.append('status', params.status);
  if (params.startDate) qs.append('startDate', params.startDate);
  if (params.endDate) qs.append('endDate', params.endDate);
  if (params.limit != null) qs.append('limit', params.limit);
  const url = `${BASE}/calls${qs.toString() ? `?${qs}` : ''}`;
  const res = await fetch(url, { headers: getAuthHeaders() });
  return res.json();
};

const getCallDetail = async (callSid) => {
  const res = await fetch(`${BASE}/calls/${callSid}`, {
    headers: getAuthHeaders(),
  });
  return res.json();
};

const getCallRecordings = async (callSid) => {
  const res = await fetch(`${BASE}/calls/${callSid}/recordings`, {
    headers: getAuthHeaders(),
  });
  return res.json();
};

/** Fetch recording audio stream (MP3). Returns blob for use in audio element or download. */
const fetchRecordingAudio = async (callSid, recordingSid) => {
  const qs = new URLSearchParams({ audio: '1' });
  if (recordingSid) qs.append('recordingSid', recordingSid);
  const res = await fetch(`${BASE}/calls/${callSid}/recordings?${qs}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  if (!res.ok) throw new Error('Failed to fetch audio');
  return res.blob();
};

const clickToCall = async (targetPhone) => {
  const res = await fetch(`${BASE}/calls/click-to-call`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ targetPhone }),
  });
  return res.json();
};

// ── Webhook Config ──────────────────────────────────────

const getWebhookConfig = async () => {
  const res = await fetch(`${BASE}/webhook-config`, {
    headers: getAuthHeaders(),
  });
  return res.json();
};

export {
  addNumber,
  listNumbers,
  updateNumber,
  getPoolStats,
  listActiveSessions,
  getSession,
  forceExpireSession,
  getCallHistory,
  getCallDetail,
  getCallRecordings,
  fetchRecordingAudio,
  clickToCall,
  getWebhookConfig,
};
